import { FunctionalReducer, IReducerAction } from 'app/redux/FunctionalReducer'
import * as Redux from 'redux'

interface ISendMailState {
  name: string
  email: string
  message: string,
  error: string
}

interface ISendMailAction extends IReducerAction {
  type: string
  sendmail?: ISendMailState
}

const ActionTypes = {
  SendMail: 'contactus/SENDMAIL'
}

const initialState: ISendMailState = {
  name: null,
  email: null,
  message: null,
  error: null,
}

const functionalReducer = new FunctionalReducer<ISendMailState, ISendMailAction>(initialState)
  .whenTypeIs(ActionTypes.SendMail, () => {
    return {
      name: null,
      email: null,
      message: null,
      error: null,
    }
  })

export {
  functionalReducer,
  ActionTypes,
  ISendMailState,
  ISendMailAction
}



// WEBPACK FOOTER //
// ./src/app/redux/SendMail/reducer/index.ts